import DesktopOnly from './DesktopOnly'
import MobileOnly from './MobileOnly'

export {DesktopOnly, MobileOnly}
